/* ============================================================
   DarthDabs — Age Gate behavior
   - Reads localStorage.dd_age_verified on load.
   - If "true", removes pending class + hides gate immediately.
   - Otherwise wires up Accept / Reject buttons.
   - Reject is terminal in-session (no way back to State 1).
   - Honors prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var STORAGE_KEY = 'dd_age_verified';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function hasReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) { return false; }
  }

  function isVerified() {
    try { return localStorage.getItem(STORAGE_KEY) === 'true'; }
    catch (e) { return false; }
  }

  function persistAccept() {
    try { localStorage.setItem(STORAGE_KEY, 'true'); }
    catch (e) { /* fail open — user has accepted in-session even if storage blocked */ }
  }

  function dismissGate(gate) {
    // Lift pre-paint + JS scroll locks.
    document.documentElement.classList.remove('dd-age-gate-pending');
    document.body.classList.remove('dd-age-gate-active');

    if (hasReducedMotion()) {
      gate.hidden = true;
      return;
    }
    gate.classList.add('is-fading-out');
    var done = function () {
      gate.hidden = true;
      gate.classList.remove('is-fading-out');
      gate.removeEventListener('transitionend', done);
    };
    gate.addEventListener('transitionend', done);
    // Safety: if transitionend doesn't fire, hide after 400ms.
    setTimeout(done, 400);
  }

  function showState(gate, name) {
    var states = gate.querySelectorAll('[data-dd-age-state]');
    for (var i = 0; i < states.length; i++) {
      var el = states[i];
      var match = el.getAttribute('data-dd-age-state') === name;
      el.hidden = !match;
    }
  }

  ready(function () {
    var gate = document.getElementById('dd-age-gate');
    if (!gate) return;

    // Already verified? Dismiss immediately, no fade.
    if (isVerified()) {
      document.documentElement.classList.remove('dd-age-gate-pending');
      document.body.classList.remove('dd-age-gate-active');
      gate.hidden = true;
      return;
    }

    // Not verified — engage scroll lock + ensure verify state visible.
    document.body.classList.add('dd-age-gate-active');
    showState(gate, 'verify');

    var acceptBtn = gate.querySelector('[data-dd-age-accept]');
    var rejectBtn = gate.querySelector('[data-dd-age-reject]');

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        persistAccept();
        dismissGate(gate);
      });
    }

    if (rejectBtn) {
      rejectBtn.addEventListener('click', function () {
        // Terminal: switch to reject state and leave it up. No persist.
        showState(gate, 'reject');
        // Keep focus inside the modal — move it to the headline of state 2.
        var h = gate.querySelector('[data-dd-age-state="reject"] .dd-age-gate__headline');
        if (h) {
          h.setAttribute('tabindex', '-1');
          try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); }
        }
      });
    }
  });
})();
